import { Button } from '@a-ui/react';
import { useSelector, useDispatch  } from 'react-redux'
import { closeModal } from '../../../store/slices/modalReducer'
import Html from '../../Html/Html'

const CancelTask = (props) => {
  const { selectedTask, data } = useSelector(state => state.tasks);
  const task = data.find((task) => task.id === selectedTask);
  const dispatch = useDispatch();
  return <>
    <Html className='u-margin-bottom'>{task.description}</Html>
    <Button onClick={() => dispatch(closeModal(false))}>Sluiten</Button>
  </>

}

export default CancelTask;
